import { render } from "./SitioCerrado.vue?vue&type=template&id=076e0deb&scoped=true"
import script from "./SitioCerrado.vue?vue&type=script&lang=js"
export * from "./SitioCerrado.vue?vue&type=script&lang=js"

import "./SitioCerrado.vue?vue&type=style&index=0&id=076e0deb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076e0deb"]])

export default __exports__